import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diagnostic-test',
  templateUrl: './diagnostic-test.component.html',
  styleUrls: ['./diagnostic-test.component.css']
})
export class DiagnosticTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/diagnostic-test/diagnostic-test.component.ts